/**
 * 提供异步请求 fetch
 *    特殊声明：
 *    APP内接入第三方请求，需求带assecc参数。
 * 例如：{access: xxxx,body:{}}
 * **/

import axios from './axios'
import sendRequest from './sendRequest'

import { isApp } from '../utils/api'

export default params => isApp ? sendRequest(params) : axios(params)
